<template>
  <!--4直播 -->
  <div class="live-section" @click="go_live_detail(dataItem)">
    <img :src="dataItem.cover_img" class="live-section-img"/>
    <div class="live-section-content">
      <div class="live-section-content-title">{{ dataItem.title }}</div>
      <div class="live-section-content-detail" v-if="dataItem.type == 2">
        共{{ dataItem.total_count }}期
        {{ dataItem.view_count }}人观看</div>
      <div class="live-section-content-detail" v-else-if="dataItem.live_status == 0">
        <span>{{ dataItem.start_at | formatDate('Y-M-D h:m')}}</span>
        <div class="live-section-content-detail-btn">
          <span  @click.stop="liveApply(dataItem)" v-if="dataItem.live_status == 0 && dataItem.isAppointment == 0">一键预约</span>
          <span  v-else-if="dataItem.live_status == 0 && dataItem.isAppointment == 1">已预约</span>
        </div>
      </div>
      <div class="live-section-content-detail" v-else-if="dataItem.live_status == 1">
        <span>{{ dataItem.start_at | formatDate('Y-M-D h:m')}}</span>
        <span>加入</span>
      </div>
      <div class="live-section-content-detail" v-else>{{ dataItem.view_count }}人观看</div>
    </div>
    <van-overlay :show="applyShow">
      <div class="apply-overlay-box">
        <div class="apply-overlay-box-wrap">
          <div class="apply-overlay-box-wrap-bg">
            <img src="/static/v4/pic_tip_success_bg.svg" />
          </div>
          <div class="apply-overlay-box-wrap-close">
            <img src="/static/v4/icon_tip_close.svg" alt="" @click="closeApplyShow" />
          </div>
          <div class="apply-overlay-box-wrap-title">
            <span>预约成功提醒</span>
          </div>
          <div class="apply-overlay-box-wrap-content">
            您已成功预约本次直播，开播前将收到短信提醒。您也可在 <span>“我的”-“我的预约”</span> 中查看您的预约情况。
            扫码领取学习资料。
          </div>
          <div class="apply-overlay-box-wrap-img">
            <img src="/static/v4/code.jpg" />
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
  name: "lives",
  props: {
    dataItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      applyShow: false
    }
  },
  methods: {
    // 直播-一键预约
    liveApply(item) {
      this.liveItem = item
      if (!item.isAppointment) {
        // 判断是否认证 0 未认证   1已认证
        let user = localStorage.getItem('user')

        let is_complete = JSON.parse(user).is_complete

        if (is_complete == 1) {
          Interface.getData('get', Interface.v4.apply + '/' + item.id).then(res => {
            if (res.code == 0) {
              this.applyShow = true
              item.isAppointment = 1
            }
          })
        } else {
          // 去认证
          this.$dialog
              .confirm({
                title: '需要登录',
                message: '为了方便学习课程,需要您登录认证',
                confirmButtonText: '去认证'
              })
              .then(() => {
                sessionStorage.setItem('back-url', this.$route.path)
                this.$router.push({ name: 'login' })
              })
              .catch(() => {
                // on cancel
              })
        }
      }else{
        Interface.goLiveDetail(this, item)
      }
    },
    go_live_detail(item) {
      Interface.goLiveDetail(this, {id: item.origin_id, type: item.type, isAppointment: item.isAppointment, live_status: item.live_status})
      Interface.mFootPrint(item.origin_id,4,0,5,0, item.title)
    },
    // 关闭预约弹框
    closeApplyShow() {
      this.applyShow = false
      // 同时跳转到直播间
      this.$router.push({ name: 'live-detail-home', params: { id: this.liveItem.id } })
    },
  }
}
</script>

<style scoped lang="scss">
.live-section{
  padding-bottom: 16px;
  &-img{
    width: 100%;
    height: 102px;
    background: linear-gradient(180deg, #ECEFF6 0%, #D7DFF3 100%);
    border-radius: 6px;
  }
  .van-image__img{
    width: 180px;
    height: 102px;
    border-radius: 6px;
  }
  &-content{
    height: 52px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 0 0 0;
    &-title{
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    &-detail{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #979797;
      &-btn{
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #D81D20;
        padding: 3px 7px;
        background: #FFF0EE;
        border-radius: 17px;
      }
    }
  }
  .apply-overlay-box{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 327px;
  height: 380px;
  background: #FFFFFF;
  border-radius: 12px;
  &-wrap{
    position: relative;
    &-bg{
      position: absolute;
      left: 0;
      top: 0;
    }
    &-close{
      text-align: right;
      padding-right: 16px;
      img{
        margin-top: 16px;
        width: 15px;
        height: 15px;
      }
    }
    &-title{
      text-align: center;
      span{
        font-size: 17px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
      }
    }
    &-content{
      margin-top: 14px;
      padding: 0 28px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      text-align: justify;
      line-height: 22px;
      span{
        color: #222;
        margin: 0 5px;
      }
    }
    &-img{
      margin-top: 50px;
      text-align: center;
      img{
        width: 140px;
        height: 140px;
      }
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/horizontalRecommend/lives.vue